import { ReadinessElaCtrl } from './readiness-ela.controller';

export const ReadinessElaStepComponent = {
  controller: ReadinessElaCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./readiness-ela.html'),
};
